module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNNTA0LjUgNzUuNWMtMTAtMTAtMjYuMi0xMC0zNi4yIDBMMTYxLjYgMzgyLjIgNDMuNyAyNjQuM2MtMTAtMTAtMjYuMi0xMC0zNi4yIDAtMTAgMTAtMTAgMjYuMjIgMCAzNi4ybDEzNiAxMzZjMTAgMTAgMjYuMiAxMCAzNi4yIDBsMzI0LjgtMzI0LjhjMTAtMTAgMTAtMjYuMiAwLTM2LjJ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/styles/form/tick.svg
// module id = ./src/styles/form/tick.svg
// module chunks = 21